// extracted by mini-css-extract-plugin
export default {"category":"CategoryDragSection_category__MvEZV"};